module.exports = "pegasus_template/assets/tech/realty/104.png";